import { Location } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CampaignEntitlements, CampaignOffersQuery, CampaignOffersService, DATE_OPTIONS, DateOptions } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { Subscription } from 'rxjs';

@Component({
  selector: 'fgb-campaign-details-page',
  templateUrl: './campaign-details-page.component.html',
  styleUrls: ['./campaign-details-page.component.scss'],
})
export class CampaignDetailsPageComponent implements OnInit, OnDestroy {
  currentCampaign: CampaignEntitlements;
  campaignOffferSub: Subscription;
  isUsedCampaign: boolean = false;
  screenSize = ScreenType;

  constructor(
    @Inject(DATE_OPTIONS) public dateOption: DateOptions,
    private route: ActivatedRoute,
    private campaignOffersService: CampaignOffersService,
    private campaignOffersQuery: CampaignOffersQuery,
    private location: Location
  ) {}

  ngOnInit() {
    let offerId = +(this.route.snapshot.paramMap.get('offerId') || '0');
    this._updateOffer(offerId);
  }

  ngOnDestroy(): void {
    this.campaignOffferSub.unsubscribe();
  }

  _updateOffer(offerId: number) {
    if (!!offerId) {
      this.campaignOffersService
        .fetchOffers()
        .toPromise()
        .then(() => {
          this.campaignOffferSub = this.campaignOffersQuery.selectFirst().subscribe((campaignOffer) => {
            if (campaignOffer) {
              for (let entitlement of campaignOffer?.CampaignsAndEntitlements) {
                if (entitlement.CampaignID === offerId) {
                  this.currentCampaign = entitlement;

                  if (
                    (this.currentCampaign.voucherRedemptions > 0 &&
                      this.currentCampaign.voucherRedemptions === this.currentCampaign.voucherUsesAvailable) ||
                    this.currentCampaign.campaignRedemptions_Quantity >= 1
                  ) {
                    // Used condition
                    this.isUsedCampaign = true;
                  }
                  break;
                }
              }
            }
          });
        });
    }
  }

  goBack() {
    this.location.back();
  }
}
